// Eksport faktur do Asseco - warstwa przegladarkowa.
//
// Reguly formatu NIE sa juz tutaj. Przeniesione do @sovo/asseco-xlsx
// (shared/asseco-xlsx/index.js), bo ten sam format musi generowac Cloud Function
// sovoPayInvoicesApi, z ktorej korzysta ekran faktur w Sovo Flow. Dwie kopie
// tych regul rozjechalyby sie - i wlasnie tak stalo sie z xlsx_generator.py.
//
// Tutaj zostaje wylacznie to, co dotyka przegladarki: pobranie pliku i Blob.
// Zmiany formatu (kolumny, rejestr, konta, daty) robimy w shared/asseco-xlsx.

import * as XLSX from 'xlsx';
import { buildWorkbook } from '@sovo/asseco-xlsx';

/**
 * Generate XLSX file from a list of settlements and trigger a browser download.
 */
export const generateXLSX = (settlements, filename = 'invoices.xlsx') => {
  XLSX.writeFile(buildWorkbook(settlements), filename);
  return filename;
};

/**
 * Generate XLSX as a blob for email attachment / programmatic use.
 */
export const getXLSXBlob = (settlements) => {
  const wbout = XLSX.write(buildWorkbook(settlements), { bookType: 'xlsx', type: 'array' });
  return new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
};

export default { generateXLSX, getXLSXBlob };
